// Canonical money formatting for PRYMEBET's dual currency (PCoins / PCash) + locked bonus.
//   cash  -> "$12.34"        redeemable sweeps PCash (USD 1:1, exact cents)
//   bonus -> "$12.34 bonus"  locked promotional PCash (1x playthrough)
//   coins -> "12.34 PCoins"  play-money gold coins
// Consolidates the formatters that were duplicated in MyBets.jsx and Casino.jsx so a PCoins win
// can never render as dollars (UIB-12) and streamer-mode masking is uniform everywhere (UIA-16).

export const MASK = "•••••";

export function isCashLike(currency) {
  return currency === "cash" || currency === "bonus";
}

function num2(v) {
  const n = Number(v) || 0;
  return n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// Full amount with the currency word/symbol. Pass { mask: streamerMode } to hide the value.
export function fmtMoney(amount, currency = "coins", opts = {}) {
  if (opts.mask) return MASK;
  const n = Number(amount) || 0;
  if (currency === "cash") return `$${n.toFixed(2)}`;
  if (currency === "bonus") return `$${n.toFixed(2)} bonus`;
  return `${num2(n)} PCoins`;
}

// Signed win/loss delta, e.g. "+$5.00" / "−12.00 PCoins".
export function fmtDelta(amount, currency = "coins", opts = {}) {
  if (opts.mask) return MASK;
  const n = Number(amount) || 0;
  const sign = n >= 0 ? "+" : "−";
  return `${sign}${fmtMoney(Math.abs(n), currency)}`;
}

// Number + symbol only (no spelled "PCoins" word) — used where a currency icon carries the unit.
export function fmtAmtNum(amount, currency = "coins", opts = {}) {
  if (opts.mask) return MASK;
  const n = Number(amount) || 0;
  return isCashLike(currency) ? `$${n.toFixed(2)}` : num2(n);
}
